import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectStatsPanel = ({ projects }) => {
  const stats = {
    total: projects?.length || 0,
    active: projects?.filter(p => p?.status === 'active')?.length || 0,
    planning: projects?.filter(p => p?.status === 'planning')?.length || 0,
    completed: projects?.filter(p => p?.status === 'completed')?.length || 0,
    avgProgress: projects?.length > 0
      ? Math.round(projects?.reduce((sum, p) => sum + p?.progress, 0) / projects?.length)
      : 0
  };

  const recentActivity = projects
    ?.sort((a, b) => new Date(b?.lastModified) - new Date(a?.lastModified))
    ?.slice(0, 3);

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="bg-card border-t border-border px-6 py-4">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Portfolio Metrics */}
        <div>
          <h3 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
            <Icon name="BarChart3" size={16} />
            Portfolio Metrics
          </h3>
          <div className="grid grid-cols-5 gap-3">
            <div className="bg-muted/50 rounded-lg p-3 text-center">
              <div className="text-2xl font-bold text-foreground mb-1">{stats?.total}</div>
              <div className="text-xs text-muted-foreground">Total Projects</div>
            </div>
            <div className="bg-success/10 rounded-lg p-3 text-center">
              <div className="text-2xl font-bold text-success mb-1">{stats?.active}</div>
              <div className="text-xs text-muted-foreground">Active</div>
            </div>
            <div className="bg-warning/10 rounded-lg p-3 text-center">
              <div className="text-2xl font-bold text-warning mb-1">{stats?.planning}</div>
              <div className="text-xs text-muted-foreground">Planning</div>
            </div>
            <div className="bg-primary/10 rounded-lg p-3 text-center">
              <div className="text-2xl font-bold text-primary mb-1">{stats?.completed}</div>
              <div className="text-xs text-muted-foreground">Completed</div>
            </div>
            <div className="bg-accent/10 rounded-lg p-3 text-center">
              <div className="text-2xl font-bold text-accent mb-1">{stats?.avgProgress}%</div>
              <div className="text-xs text-muted-foreground">Avg Progress</div>
            </div>
          </div>
        </div>

        {/* Recent Activity */}
        <div>
          <h3 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
            <Icon name="Activity" size={16} />
            Recent Activity
          </h3>
          <div className="space-y-2">
            {recentActivity?.length > 0 ? (
              recentActivity?.map((project) => (
                <div
                  key={project?.id}
                  className="flex items-center justify-between bg-muted/50 rounded-lg p-2.5 hover:bg-muted transition-colors"
                >
                  <div className="flex items-center gap-3 flex-1 min-w-0">
                    <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center shrink-0">
                      <Icon name="Folder" size={16} color="var(--color-primary)" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-foreground truncate">{project?.name}</p>
                      <p className="text-xs text-muted-foreground">Modified by {project?.owner}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 text-xs text-muted-foreground shrink-0">
                    <Icon name="Clock" size={12} />
                    <span>{formatTime(project?.lastModified)}</span>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center py-4 text-sm text-muted-foreground">
                No recent activity
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectStatsPanel;